export const CREDIT_CHANNEL = 'GT_Bank';
export const CREDIT_SOURCE = 'float_balance';
export const CREDIT_DESTINATION_USER = 'individual_wallet';
export const CREDIT_DESTINATION_GROUP = 'group_wallet';
export const TOPUP_CHANNEL = CREDIT_CHANNEL;
